import { Dictionary } from 'lodash';
import { User } from 'api/models';
import { SchedulerReference } from '../../types';
import { useAllocationEventTooltip } from './allocation-event';
import { useAutoAllocateTooltip } from './auto-allocate';
import { useCommonEventTooltip } from './common-events';
import { useOverallocationTooltip } from './overallocation';
import { usePlaceholderTooltip } from './placeholder';
import { useTaskIntensityTooltip } from './task-intensity';
import { useTimeoffTooltip } from './timeoff-events';

export const useEventsTooltip = (
  ref: SchedulerReference,
  userLookup: Dictionary<User>,
): void => {
  useCommonEventTooltip(ref, userLookup);
  useAllocationEventTooltip(ref);
  usePlaceholderTooltip(ref);
  useOverallocationTooltip(ref);
  useTaskIntensityTooltip(ref);
  useTimeoffTooltip(ref);
  useAutoAllocateTooltip(ref);
};
